import {
  login,
  register,
  forgotPassword,
  resendPasswordPolicyEmail,
  sendLoginOtp,
  verifyLoginOtp,
  sendMobileLoginOtp,
  verifyMobileLoginOtp,
  isEmailRequiredForRegistrationError,
  isEmailAlreadyExistsError,
  isOtpRateLimitError,
} from './auth';
import {
  validationSchemaLogin,
  validationSchemaSignUp,
  validationSchemaForgot,
  validationSchemaOtp,
  validationSchemaMobileOtpLogin,
} from './formValidator';

export {
  login,
  register,
  forgotPassword,
  resendPasswordPolicyEmail,
  sendLoginOtp,
  verifyLoginOtp,
  sendMobileLoginOtp,
  verifyMobileLoginOtp,
  isEmailRequiredForRegistrationError,
  isEmailAlreadyExistsError,
  isOtpRateLimitError,
  validationSchemaLogin,
  validationSchemaSignUp,
  validationSchemaForgot,
  validationSchemaOtp,
  validationSchemaMobileOtpLogin,
};
